import pageBuilderPermissions from "./PageBuilderPermissions";

export default pageBuilderPermissions;
